import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import PromoBanner from './components/PromoBanner';
import ProductShowcase from './components/ProductShowcase';
import KnowledgeSection from './components/KnowledgeSection';
import Testimonials from './components/Testimonials';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <PromoBanner />
        <ProductShowcase />

        {/* ProductShowcase → KnowledgeSection 波浪过渡 */}
        <div className="relative -mb-1 overflow-hidden leading-none bg-[#FAF8F5]">
          <svg
            viewBox="0 0 1440 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            className="w-full h-8 md:h-12"
          >
            <path
              d="M0 60L48 55C96 50 192 40 288 36C384 32 480 32 576 34C672 36 768 40 864 44C960 48 1056 52 1152 50C1248 48 1344 40 1392 36L1440 32V0H1392C1344 0 1248 0 1152 0C1056 0 960 0 864 0C768 0 672 0 576 0C480 0 384 0 288 0C192 0 96 0 48 0H0V60Z"
              fill="white"
            />
          </svg>
        </div>
        <KnowledgeSection />

        {/* KnowledgeSection → Testimonials 波浪过渡 */}
        <div className="relative -mb-1 overflow-hidden leading-none bg-white">
          <svg
            viewBox="0 0 1440 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            className="w-full h-8 md:h-12"
          >
            <path
              d="M0 60L48 55C96 50 192 40 288 36C384 32 480 32 576 34C672 36 768 40 864 44C960 48 1056 52 1152 50C1248 48 1344 40 1392 36L1440 32V0H1392C1344 0 1248 0 1152 0C1056 0 960 0 864 0C768 0 672 0 576 0C480 0 384 0 288 0C192 0 96 0 48 0H0V60Z"
              fill="#FAF8F5"
            />
          </svg>
        </div>
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
}